export default __webpack_public_path__ + "static/media/thunderstorm.f8801f59.svg";